<template>
    <div class="step" :class="{ 'step-compact': compact }">
        <div class="step-list" v-for="(item, index) in list" :key="index"
            :style="{ left: 'calc(' + left_num + 'px * ' + index + ')' }">
            <div v-if="index == 0">
                <img src="../../../../static/images/icon/icon25.png" alt="" v-if="index == indexValue"
                    :style="{ width: width_num + 'px' }">
                <img src="../../../../static/images/icon/icon26.png" alt="" v-else :style="{ width: width_num + 'px' }">
            </div>
            <div v-else>
                <img src="../../../../static/images/icon/icon27.png" alt="" v-if="index == indexValue"
                    :style="{ width: width_num + 'px' }">
                <img src="../../../../static/images/icon/icon28.png" alt="" v-else :style="{ width: width_num + 'px' }">
            </div>
            <div class="list-box">
                <span class="margin-right-8">{{ index + 1 }}</span>
                <span>{{ item.txt }}</span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ShoppingProcess',
    props: {
        list: {
            type: Array,
            required: true,
            default: () => []
        },
        indexValue: {
            type: [String, Number],
            required: true,
            default: () => ''
        },
        compact: {
            type: Boolean,
            default: false
        }
    },
    watch: {
        list: {
            immediate: true,
            handler(newList) {
                if (newList && newList.length > 0) {
                    this.updateImagePaths(newList);
                }
            }
        },
        compact() {
            if (this.list && this.list.length > 0) {
                this.updateImagePaths(this.list);
            }
        }
    },
    data() {
        return {
            width_num: 0,
            left_num: 0,
        }
    },
    methods: {
        updateImagePaths(e) {
            if (e.length == 5) {
                this.width_num = this.compact ? 78 : 267
                this.left_num = this.compact ? -11 : -30
            } else if (e.length == 4) {
                this.width_num = this.compact ? 98 : 333
                this.left_num = this.compact ? -14 : -40
            } else if (e.length == 3) {
                this.width_num = this.compact ? 128 : 439
                this.left_num = this.compact ? -18 : -50
            }
        }
    }
};
</script>

<style scoped lang="scss">
.step {
    display: flex;

    &:not(.step-compact) {
        min-width: fit-content;
    }

    &.step-compact {
        width: 100%;
        min-width: 0;
    }

    .step-list {
        flex-shrink: 0;
        height: 80px;
        position: relative;

        img {
            height: 80px;
        }

        .list-box {
            font-size: 16px;
            position: absolute;
            height: 100%;
            width: 100%;
            top: 0;
            left: 0;
            text-align: center;
            line-height: 80px;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/view/order/components/ShoppingProcess.vue